/**
 * Show global loading bar
 * @returns {Function}
 */
export const instanceConfigured = (instance) => ({
    type: 'INSTANCE_CONFIGURED',
    instance: {
        data: instance,
        error: null
    }
});

/**
 * Hide global loading bar
 * @returns {Function}
 */
export const instanceError = ({ humanError = "", devError = ""} = {}) => ({
    type: 'INSTANCE_ERROR',
    instance: {
        data: null,
        error: {
            humanError,
            devError
        }
    }
});
